export const calculateTotalPortfolioValue = (portfolio) => portfolio.reduce((acc, curr) => acc + curr.holdingsValue, 0);

export const calculateTotalPortfolioRevenue = (portfolio) => portfolio.reduce((acc, curr) => acc + curr.arr, 0);
